import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MainService } from 'src/app/services/main/main.service';

@Component({
    selector: 'app-verification',
    templateUrl: './verification.component.html',
    styleUrls: ['./verification.component.scss']
})
export class VerificationComponent implements OnInit {

    constructor(private route: ActivatedRoute, public mainService: MainService) { }
    success = false;
    errorMessage = '';
    ngOnInit() {
        if (this.route.snapshot.queryParams.link_id) {
            this.getapfInfo(this.route.snapshot.queryParams.link_id);
        } else {
            this.errorMessage = 'Your link is invalid';
        }
    }
    getapfInfo(token) {
        if (token) {
            this.mainService.api({ verification_token: token }, 'verify_email', true)
                .subscribe((data: any) => {
                    if (data.is_error === 0) {
                        this.success = true;
                    } else {
                        this.success = false;
                        this.errorMessage = 'Your link has been expired.';
                    }
                });
        } else {
            this.errorMessage = 'Your link is invalid';
        }
    }
}
